import CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';

export const CodemirrorArea = {
    props: {
        value: {
            type: String,
            default: '',
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        lineWrapping: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'javascript',
        },
        bottomHeight: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            codemirror: null,
        };
    },
    computed: {
        codemirrorMode() {
            if (this.mode === 'javascript') {
                return { name: 'javascript', json: true };
            }
            return this.mode;
        }
    },
    mounted() {
        this.codemirror = CodeMirror(this.$refs.codemirror, {
            value: this.value,
            mode: this.codemirrorMode,
            lineNumbers: true,
            readOnly: this.readOnly,
            lineWrapping: this.lineWrapping,
        });
        this.codemirror.on('change', this.emitInput);

        this.$nextTick(() => {
            this.codemirror.refresh();
            this.codemirror.setSize('100%', '100%');
        });
    },
    methods: {
        emitInput() {
            this.$emit('input', this.codemirror.getValue());
        },
    },
    watch: {
        value(newValue) {
            if (this.codemirror && newValue !== this.codemirror.getValue()) {
                this.codemirror.setValue(newValue);

                this.$nextTick(() => {
                    this.codemirror.refresh();
                });
            }
        },
        readOnly(newVal) {
            if (this.codemirror) {
                this.codemirror.setOption('readOnly', newVal);
            }
        },
        mode(newMode) {
            if (this.codemirror) {
                this.codemirror.setOption('mode', newMode);
            }
        },
    },
    template: `
        <div class="code-wrapper"  :style="bottomHeight ? { height: bottomHeight + 'px' } : { height: '100%' }">
            <div ref="codemirror" class="codemirror-container" style="height:100%"></div>
        </div>
      </div>
    `,
};
